import React from 'react'

const Banner = () => {
    return (
        <div className="bg-red-600 text-white font-medium justify-center flex items-center p-2 mb-5">
            <p>
                Please Read This Urgent Message To Avoid Your Card Being Double-Charged.
            </p>
        </div>
    )
}

export default Banner
